import { currencies, defaultCurrency } from 'common/constants';
import { Currency } from 'common/types';

export const sumWithCurrency = (sum: number, currency?: Currency): string => {
  const currencyData = currencies[currency || defaultCurrency];
  return currencyData.symbolPosition === 'after'
    ? `${sum.toFixed(2)} ${currencyData.symbol}`
    : `${currencyData.symbol} ${sum.toFixed(2)}`;
};
